export default {
  disableServiceTitle: "disableServiceTitle",
  disableServiceSubtitle: "disableServiceSubtitle",
  scheduledDisableTitle: "scheduledDisableTitle",
  scheduledDisableSubtitle: "scheduledDisableSubtitle",
  reasonLabel: "reasonLabel",
  reasonRequired: "reasonRequired",
  customDateRequired: "customDateRequired",
  durationLabel: "durationLabel",
  autoResumeLabel: "autoResumeLabel",
  autoResumeOnDateLabel: "autoResumeOnDateLabel",
  duration_1h: "duration_1h",
  duration_2h: "duration_2h",
  duration_1d: "duration_1d",
  duration_1w: "duration_1w",
  duration_1m: "duration_1m",
  duration_custom: "duration_custom",
  duration_permanent: "duration_permanent",
  reasonSelectPlaceholder: "reasonSelectPlaceholder",
  reasonPosIssue: "reasonPosIssue",
  reasonStaffShortage: "reasonStaffShortage",
  reasonRamadanHours: "reasonRamadanHours",
  reasonMaintenance: "reasonMaintenance",
  reasonBrandRequest: "reasonBrandRequest",
  reasonOther: "reasonOther",
  specifyReasonPlaceholder: "specifyReasonPlaceholder",
  cancel: "cancel",
  apply: "apply",
  save: "save",
  confirmDisable: "confirmDisable",
  enable: "enable",
  updateScheduled: "updateScheduled",
  pickup: "pickup",
  delivery: "delivery",
  driveThru: "driveThru",
  offlineLoyalty: "offlineLoyalty",
  onlineLoyalty: "onlineLoyalty",
  scheduledDisableTooltip: "scheduledDisableTooltip",
  badgeUntilLabel: "badgeUntilLabel",
  badgePermanentLabel: "badgePermanentLabel",
  badgeReasonLabel: "badgeReasonLabel",
  badgeDurationLabel: "badgeDurationLabel",
};
